import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
// import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import * as countActions from "@rentiohq/shared-frontend/dist/redux/count/count.actions";
import * as countSelectors from "@rentiohq/shared-frontend/dist/redux/count/count.selectors";
import * as expertInquirySelectors from "@rentiohq/shared-frontend/dist/redux/expertInquiry/expertInquiry.selectors";
import * as rentDepositActions from "@rentiohq/shared-frontend/dist/redux/rentDeposit/rentDeposit.actions";
import * as rentDepositSelectors from "@rentiohq/shared-frontend/dist/redux/rentDeposit/rentDeposit.selectors";
import * as contractHooks from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.hooks";
// import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
// import { EPaymentOrderType } from "@rentiohq/shared-frontend/dist/types/payment.types";
// import { EPaymentRequestStatus } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { IRegistration } from "@rentiohq/shared-frontend/dist/types/registration.types";
import { ERentDepositStatus } from "@rentiohq/shared-frontend/dist/types/rentDeposit.types";
import { appendWhere } from "@rentiohq/shared-frontend/dist/utils/api.utils";
import { getIsShowExitChecklist } from "@rentiohq/shared-frontend/dist/utils/contract.utils";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";
import { EAdministrationItems } from "../AdministrationItems/AdministrationItems.types";
import {
  //   getRentioMoveServiceForExitMessage,
  getOutstandingPaymentOrderMessage,
  getOutgoingPropertyInspectionReportMessage,
  getRentDepositReleaseMessage,
} from "./../../ContractCard.utils";

export const useGetExitChecklistItems = (params: {
  contract: IContract;
  property: IProperty;
  registration?: IRegistration;

  // Callbacks
  onIndexContract: () => void;
  onShowRentDeposit: (rentDepositId: number) => void;
  onOrderPropertyInspectionReport: () => void;
  onCreateRentioMoveRequest: () => void;
  onShowMoveRequest: (moveRequestId: number) => void;

  // Config
  shouldFetchData: boolean;
}) => {
  const {
    contract,
    property,
    onShowRentDeposit,
    onOrderPropertyInspectionReport,
    // onCreateRentioMoveRequest,
    // onShowMoveRequest,

    shouldFetchData,
  } = params;

  const showExitChecklist = getIsShowExitChecklist(contract);

  const dispatch = useDispatch();

  const { isBroker, broker } = authHooks.useSelf();

  const { update: updateContract } = contractHooks.useUpdate({
    id: contract.id,
  });

  // Rent deposits
  const rentDepositsIdentifier = `rent-deposits-contract-${contract.id}`;

  const isFetchingRentDeposits = useSelector((state: IRootStore) =>
    rentDepositSelectors.isFetchingRentDeposits(state, rentDepositsIdentifier),
  );
  const rentDeposits = useSelector((state: IRootStore) =>
    rentDepositSelectors.getRentDeposits(state, rentDepositsIdentifier),
  );

  // Payment orders
  const contractsPaymentOrdersCountIdentifier = `contracts-payment-orders-count-${contract.id}`;

  const isFetchingPaymentOrdersCount =
    useSelector((state: IRootStore) =>
      countSelectors.getIsFetchingCount(
        state,
        contractsPaymentOrdersCountIdentifier,
      ),
    ) || 0;
  const paymentOrdersCount =
    useSelector((state: IRootStore) =>
      countSelectors.getCount(state, contractsPaymentOrdersCountIdentifier),
    ) || 0;

  // Property inspection report
  const partnerships = useSelector((state: IRootStore) =>
    expertInquirySelectors.partnerships(state),
  );

  //   const hasRentioMoveServiceForBroker = brokerHooks.useBrokerFeature(
  //     EBrokerFeature.RentioMove,
  //   );

  // Actions
  // Rent deposits
  React.useEffect(() => {
    if (!shouldFetchData) {
      return;
    }

    dispatch(
      rentDepositActions.getRentDeposits.actions.start({
        identifier: rentDepositsIdentifier,
        refetch: true,
        extraFilterData: {
          where: {
            basicContractId: contract.id,
            status: { neq: ERentDepositStatus.Cancelled },
          },
          order: "createdAt DESC",
        },
        limit: 1,
      }),
    );
  }, [contract, shouldFetchData]);

  // Payment orders
  React.useEffect(() => {
    if (!shouldFetchData) {
      return;
    }

    dispatch(
      countActions.getCount.actions.start({
        countIdentifier: contractsPaymentOrdersCountIdentifier,
        countBase: appendWhere("/payment-orders/count", {
          and: [{ contractId: contract.id }, { completedAt: null }],
        }),
      }),
    );
  }, [contract, shouldFetchData]);

  if (!showExitChecklist) {
    return;
  }

  // Build checklist items
  const checklistItems = {
    [EAdministrationItems.DepositRelease]: getRentDepositReleaseMessage({
      property,
      contract,

      // Callbacks
      onShowRentDeposit,

      // Actions
      updateContract,

      // Config
      rentDeposit: rentDeposits?.[0],
      isFetchingRentDeposit: isFetchingRentDeposits || false,
    }),
    [EAdministrationItems.OutstandingPayments]:
      getOutstandingPaymentOrderMessage({
        property,
        contract,

        // Actions
        updateContract,

        // Config
        isBroker,
        paymentOrdersCount,
        isFetchingPaymentOrdersCount: isFetchingPaymentOrdersCount || false,
      }),
    [EAdministrationItems.OutgoingPropertyInspectionReport]:
      getOutgoingPropertyInspectionReportMessage({
        property,
        contract,
        isBroker,
        broker,

        // Callbacks
        onOrderPropertyInspectionReport,

        // Actions
        updateContract,

        // Config
        partnerships,
      }),
    // ...(hasRentioMoveServiceForBroker || Boolean(contract.rentioMoveStatus)
    //   ? {
    //       [EAdministrationItems.OutgoingMove]: getRentioMoveServiceForExitMessage({
    //         property,
    //         contract,

    //         // Callbacks
    //         onCreateRentioMoveRequest,
    //         onShowMoveRequest,

    //         // Actions
    //         updateContract,

    //         // Config
    //         isBroker,
    //         hasRentioMoveServiceForBroker,
    //         internalModeEnabled,
    //       }),
    //     }
    //   : {}),
  };

  return Object.fromEntries(
    Object.entries(checklistItems).filter(([_, value]) => Boolean(value)),
  );
};
